import { CLOSE_SNACKBAR } from '../constants/actiontypes';

export const closeSnackBar = () => ({
  type: CLOSE_SNACKBAR,
});
